import _run from "./lib/run";
import _config from "./lib/config";
var exports = {};
var __importDefault = exports && exports.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.POPULAR_TLDS = exports.POPULAR_DOMAINS = exports.run = void 0;
const run_1 = __importDefault(_run);
exports.run = run_1.default;
const config_1 = _config;
Object.defineProperty(exports, "POPULAR_DOMAINS", {
  enumerable: true,
  get: function () {
    return config_1.POPULAR_DOMAINS;
  }
});
Object.defineProperty(exports, "POPULAR_TLDS", {
  enumerable: true,
  get: function () {
    return config_1.POPULAR_TLDS;
  }
});
const MailSpellChecker = {
  run: run_1.default,
  POPULAR_DOMAINS: config_1.POPULAR_DOMAINS,
  POPULAR_TLDS: config_1.POPULAR_TLDS
};
exports.default = MailSpellChecker;
export default exports;
export const __esModule = exports.__esModule,
  POPULAR_TLDS = exports.POPULAR_TLDS,
  POPULAR_DOMAINS = exports.POPULAR_DOMAINS,
  run = exports.run;